import { render } from "./CIS-Hardened-Images-List-Column-Header.vue?vue&type=template&id=fafb9a66&scoped=true"
import script from "./CIS-Hardened-Images-List-Column-Header.vue?vue&type=script&lang=js"
export * from "./CIS-Hardened-Images-List-Column-Header.vue?vue&type=script&lang=js"

import "./CIS-Hardened-Images-List-Column-Header.vue?vue&type=style&index=0&id=fafb9a66&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fafb9a66"]])

export default __exports__